import { useState } from "react";

const ProfilePic = ({profileData}) => {

    const [imgSrc, setImgSrc] = useState(profileData?.avatar);

    return (
        <div className='rounded-circle my-3 profile-image-circle' style={{height: '150px', width: "150px", cursor: 'pointer', wordWrap: 'break-word', marginLeft:'25px'}}>
            <img src={imgSrc} 
                className='w-100 h-100 rounded-circle' 
                alt="profile"
                onError={() => setImgSrc(`https://avatar.iran.liara.run/username?username=${profileData?.name}`)}
                ></img>
        </div>
    )
}

export default ProfilePic;